import React from 'react';

import Widget from '../../widget/Widget';
import WidgetModal from '../../widget/WidgetModal';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';


import '../../css/analysis.css';

class IntellectualProperty extends React.Component
{
    constructor(props)
    {
        super(props);

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        let entname = Widget.getSessionStorage("entname");

        this.state = {

            // 申请专利
            options:{
                'url':url,
                'records':5,
                'title':'专利申请'
            },
            columns:[
                {name:'NAME', title:'专利名称', type:'string', properties:{"click":"patentDetail"}},
                {name:'PATTYPE', title:'专利类型', type:'string'},
                {name:'LAWSTATE', title:'法律状态', type:'string'},
                {name:'VALIDITY', title:'专利有效性', type:'string'},
                {name:'APPDATE', title:'申请日期', type:'date'},
                {name:'PUBNO', title:'公开号', type:'string', properties:{"hidden":true}},
                {name:'APPNO', title:'申请号', type:'string', properties:{"hidden":true}},
                {name:'MAINCLSNO', title:'主分类号', type:'string', properties:{"hidden":true}},
                {name:'CLSNO', title:'分类号', type:'string', properties:{"hidden":true}},
                {name:'APPLICANT', title:'申请（专利）人', type:'string', properties:{"hidden":true}},
                {name:'INVENTOR', title:'发明人', type:'string', properties:{"hidden":true}},
                {name:'AGENCY', title:'专利代理机构', type:'string', properties:{"hidden":true}},
                {name:'AGENT', title:'代理人', type:'string', properties:{"hidden":true}},
            ],
            params :{
                'service':'getPatentInfo',
                'user':UID,
                'ENTNAME' : entname
            },
            patentOptions:{
                name:"patent",
                title:"标题",
                size :"md"
            },
            patentData:{
                PATTYPE: "",
                APPDATE: "",
                PUBNO: "",
                APPNO: "",
                MAINCLSNO: "",
                CLSNO: "",
                APPLICANT: "",
                INVENTOR: "",
                AGENCY: "",
                AGENT: "",
            },

            //商标注册
            options2:{
                'url':url,
                'records':5,
                'title':'商标注册'
            },
            columns2:[
                {name:'NAME', title:'商标名称', type:'string', properties:{"click":"brandDetail"}},
                {name:'TMREGNO', title:'注册号', type:'string'},
                {name:'IS_COMMON', title:'是否共有商标', type:'string'},
                {name:'APPDATE', title:'申请日期', type:'date'},
                {name:'TMSTATE', title:'商标状态', type:'string'},
                {name:'TMTYPE', title:'商标类型', type:'string', properties:{"hidden":true}},
                {name:'AGENCY', title:'代理机构', type:'string', properties:{"hidden":true}},
                {name:'PROPFROM', title:'专用期起', type:'string', properties:{"hidden":true}},
                {name:'PROPTO', title:'专用期止', type:'string', properties:{"hidden":true}},
                {name:'COLOR', title:'指定颜色', type:'string', properties:{"hidden":true}},
                {name:'CHKANNCDATE', title:'初审公告日期', type:'string', properties:{"hidden":true}},
                {name:'CHKANNCTERM', title:'初审公告期号', type:'string', properties:{"hidden":true}},
                {name:'REGANNCDATE', title:'注册公告日期', type:'string', properties:{"hidden":true}},
                {name:'REGANNCTERM', title:'注册公告期号', type:'string', properties:{"hidden":true}},
            ],
            params2 :{
                'service':'getTrademarkInfo',
                'user':UID,
                'ENTNAME' : entname
            },
            brandOptions:{
                name:"brand",
                title:"标题",
                size :"md"
            },
            brandData:{
                APPDATE: "",
                TMREGNO: "",
                TMTYPE: "",
                AGENCY: "",
                PROPFROM: "",
                PROPTO: "",
                COLOR: "",
                IS_COMMON: "",
                CHKANNCDATE: "",
                CHKANNCTERM: "",
                REGANNCDATE: "",
                REGANNCTERM: "",
            },

            //软件著作权
            options3:{
                'url':url,
                'records':5,
                'title':'软件著作权'
            },
            columns3:[
                {name:'NAME', title:'软件名称', type:'string'},
                {name:'VERSION', title:'版本', type:'string'},
                {name:'SWCLS', title:'软件分类', type:'string'},
                {name:'FRTPUBDATE', title:'首次发表日期', type:'date'},
                {name:'REGDATE', title:'登记日期', type:'date'},
                {name:'OWNER', title:'著作权人', type:'string', properties:{"hidden":true}},
                {name:'SHORTNAME', title:'软件简称', type:'string', properties:{"hidden":true}},
                {name:'SWIND', title:'行业领域', type:'string', properties:{"hidden":true}},
                {name:'SWRREGNO', title:'登记号', type:'string', properties:{"hidden":true}}
            ],
            params3 :{
                'service':'getSoftwareCopyrightInfo',
                'user':UID,
                'ENTNAME' : entname
            },

            //作品著作权
            options4:{
                'url':url,
                'records':5,
                'title':'作品著作权'
            },
            columns4:[
                {name:'NAME', title:'作品名称', type:'string'},
                {name:'WKSCLS', title:'作品类别', type:'string'},
                {name:'WKSREGNO', title:'登记号', type:'string'},
                {name:'CMPLDATE', title:'创作完成日期', type:'date'},
                {name:'REGDATE', title:'登记日期', type:'date'},
                {name:'OWNER', title:'著作权人', type:'date'}
            ],
            params4 :{
                'service':'getWorksCopyrightInfo',
                'user':UID,
                'ENTNAME' : entname
            },
        };

        this.onLoadToken = this.onLoadToken.bind(this);
        this.notify = this.notify.bind(this);

        Config.getHermesAccess( this.onLoadToken );
    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        let { params, params2, params3, params4 } = this.state;
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
            params2["access"] =  result.result.token;
            params3["access"] =  result.result.token;
            params4["access"] =  result.result.token;
  
            this.setState({
                params:params,
                params2:params2,
                params3:params3,
                params4:params4
            }); 
        }
        else
        {
            return ;
        }  
    }

    change( item )
    {
        for( let i=0; i<item.target.parentNode.childNodes.length; i++ )
        {
            item.target.parentNode.childNodes[i].className = "title-label";
        }
        item.target.className = 'title-label title-label-active';

        let e = document.getElementById(item.currentTarget.id.substring(1));
        e.scrollIntoView({behavior:'smooth'}); 
    }

    onRef = (ref) => {
        if( ref.props.options.name === "patent" )
        {
            this.patentModal =  ref ;
        }
        else if( ref.props.options.name === "brand" )
        {
            this.brandModal = ref;
        }
        
    }

    notify(type, data, value) 
    {
        switch( type )
        {
            case "patentDetail":
            {
                let { patentOptions } = this.state;

                patentOptions["title"] = value;

                data = JSON.parse(data);
                
                this.setState({
                    patentData:{
                        PATTYPE:data.PATTYPE,
                        APPDATE: data.APPDATE,
                        PUBNO: data.PUBNO,
                        APPNO: data.APPNO,
                        MAINCLSNO: data.MAINCLSNO,
                        CLSNO: data.CLSNO,
                        APPLICANT: data.APPLICANT,
                        INVENTOR: data.INVENTOR,
                        AGENCY: data.AGENCY,
                        AGENT: data.AGENT,
                    },
                    patentOptions:patentOptions
                })
                
                this.patentModal.open();

                break;
            }

            case "brandDetail":
            {
                let { brandOptions } = this.state;

                brandOptions["title"] = value;

                data = JSON.parse(data);
                
                this.setState({
                    brandData:{
                        APPDATE: data.APPDATE,
                        TMREGNO: data.TMREGNO,
                        TMTYPE: data.TMTYPE,
                        AGENCY: data.AGENCY,
                        PROPFROM: data.PROPFROM,
                        PROPTO: data.PROPTO,
                        COLOR: data.COLOR,
                        IS_COMMON: data.IS_COMMON,
                        CHKANNCDATE: data.CHKANNCDATE,
                        CHKANNCTERM: data.CHKANNCTERM,
                        REGANNCDATE: data.REGANNCDATE,
                        REGANNCTERM: data.REGANNCTERM,
                    },
                    brandOptions:brandOptions
                })
                
                this.brandModal.open();

                break;
            }
            default :
                break;
        }
    }

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            this.state["params2"]["ENTNAME"] = entname;
            this.state["params3"]["ENTNAME"] = entname;
            this.state["params4"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }


        
    }

    render() 
	{

        const { options, columns, params, patentOptions, patentData,  options2, columns2, params2, brandOptions, brandData, options3, columns3, params3, options4, columns4, params4 } = this.state;
        
        return(
            <div className="page">
                {/* label */}
                {/* <div className="page-weidu entity-title">
                    <div id="0patentApp" className="title-label title-label-active" onClick={this.change.bind(this)}>专利申请</div>
                    <div id="0brandRegister" className="title-label " onClick={this.change.bind(this)}>商标注册</div>
                    <div id="0softwareCopyright" className="title-label " onClick={this.change.bind(this)}>软件著作权</div>
                    <div id="0worksCopyright" className="title-label " onClick={this.change.bind(this)}>作品著作权</div>
                </div> */}

                <div className="page-content page-overflow page-content-custom white padding-20">
                    {/* 专利申请 */}
                    <div id="patentApp" className="content-top content-canvas-custom border-top-left-radius-0">
                        <WidgetInterfaceTable options={options} columns={columns} params={params} notify={this.notify}/>
                    </div>
                    {/* 专利申请弹出框 */}
                    <WidgetModal options={patentOptions} onRef={this.onRef}>
                        <div className="baseInfo">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>专利类型 :</td>
                                        <td id="patentType">{patentData.PATTYPE}</td>
                                        <td>申请日期 :</td>
                                        <td id="applicationDate">{patentData.APPDATE}</td>
                                    </tr>
                                    <tr>
                                        <td>公开号 :</td>
                                        <td id="openNumber">{patentData.PUBNO}</td>
                                        <td>申请号 :</td>
                                        <td id="applicationNumber">{patentData.APPNO}</td>
                                    </tr>
                                    <tr>
                                        <td>主分类号 :</td>
                                        <td id="mainClassNumber">{patentData.MAINCLSNO}</td>
                                        <td>分类号 :</td>
                                        <td id="classNumber">{patentData.CLSNO}</td>
                                    </tr>
                                    <tr>
                                        <td>申请（专利）人 :</td>
                                        <td colspan="3" id="applicant">{patentData.APPLICANT}</td>
                                    </tr>
                                    <tr>
                                        <td>发明人 :</td>
                                        <td colspan="3" id="inventor">{patentData.INVENTOR}</td>
                                    </tr>
                                    <tr>
                                        <td>专利代理机构 :</td>
                                        <td id="patentAgentMechanism">{patentData.AGENCY}</td>
                                        <td>代理人 :</td>
                                        <td id="patentPerson">{patentData.AGENT}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </WidgetModal>

                    {/* 商标注册 */}
                    <div id="brandRegister" className="content-top content-canvas-custom">
                        <WidgetInterfaceTable options={options2} columns={columns2} params={params2} notify={this.notify} />
                    </div>

                    {/* 商标注册弹出框 */}
                    <WidgetModal options={brandOptions} onRef={this.onRef}>
                        <div className="baseInfo">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>申请日期 :</td>
                                        <td id="markApplicationDate">{brandData.APPDATE}</td>
                                        <td>商标注册号 :</td>
                                        <td id="tradeMarkNumber">{brandData.TMREGNO}</td>
                                    </tr>
                                    <tr>
                                        <td>商标类型 :</td>
                                        <td id="markType">{brandData.TMTYPE}</td>
                                        <td>代理机构 :</td>
                                        <td id="agency">{brandData.AGENCY}</td>
                                    </tr>
                                    <tr>
                                        <td>专用期起 :</td>
                                        <td id="specialDateStart">{brandData.PROPFROM}</td>
                                        <td>专用期止 :</td>
                                        <td id="specialDateEnd">{brandData.PROPTO}</td>
                                    </tr>
                                    <tr>
                                        <td>指定颜色 :</td>
                                        <td id="appointColor">{brandData.COLOR}</td>
                                        <td>是否共有商标 :</td>
                                        <td id="commonTradeMark">{brandData.IS_COMMON}</td>
                                    </tr>
                                    <tr>
                                        <td>初审公告日期 :</td>
                                        <td id="annountcementDate">{brandData.CHKANNCDATE}</td>
                                        <td>初审公告期号 :</td>
                                        <td id="annountcementNumber">{brandData.CHKANNCTERM}</td>
                                    </tr>
                                    <tr>
                                        <td>注册公告日期 :</td>
                                        <td id="registerDate">{brandData.REGANNCDATE}</td>
                                        <td>注册公告期号 :</td>
                                        <td id="registerNumber">{brandData.REGANNCTERM}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </WidgetModal>

                    {/* 软件著作权 */}
                    <div id="softwareCopyright" className="content-top content-canvas-custom ">
                        <WidgetInterfaceTable options={options3} columns={columns3} params={params3} />
                    </div>

                    {/* 作品著作权 */}
                    <div id="worksCopyright" className="content-top content-canvas-custom ">
                        <WidgetInterfaceTable options={options4} columns={columns4} params={params4} />
                    </div>
                </div>
            </div>
        );
    }

}

export default IntellectualProperty